import { LitElement, css, html } from "lit"
import {property, customElement} from 'lit/decorators.js';

/**
 * In order to be notified of value changes 2 custom events exist:
 * change: Which will be triggered when the user has comitted a new value (e.g. let go of the mouse)
 * input: Which will be triggered for any value change during the adjustment, until comitting.
 */

@customElement('voy-input-range')
export class VoyFleetSubViewNearestPort extends LitElement {
    @property({ type: Number }) public min: number = 0
    @property({ type: Number }) public max: number = 2
    @property({ type: Number, attribute: false }) public value: number = 1

    constructor() {
        super()

        this._change = this._change.bind(this)
        this._input = this._input.bind(this)
    }

    static get styles() {
        return css`
            .container {
                display: flex;
                flex-direction: column;
                row-gap: 4px;
            }
            .range {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .range p {
                font-size: 14px;
                line-height: 20px;
                font-weight: 400;
                margin: 0;
                color: var(--neutrals-grey-01)
            }
            input {
                -webkit-appearance: none;
                appearance: none;
                width: 100%;
                height: 2px;
                background: var(--neutrals-grey-01);
                outline: none;
                opacity: 0.7;
            }
            input::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: var(--voyage-blue-dark);
                cursor: pointer;
            }
        `
    }

    private _change(e: Event) {
        const { value } = e.target as HTMLInputElement
        e.stopPropagation()
        this.dispatchEvent(new CustomEvent("change", { detail: { value } }))
    }

    private _input(e: Event) {
        const { value } = e.target as HTMLInputElement
        e.stopPropagation()
        this.dispatchEvent(new CustomEvent("input", { detail: { value } }))
    }

    render() {
        return html`
            <div class="container">
                <input class="slider" type="range" step="0.1" .value=${this.value} min=${this.min} max=${this.max} @input=${this._input} @change=${this._change} />
                <div class="range">
                    <p>${this.min}</p>
                    <p>${this.max}</p>
                </div>
            </div>
        `
    }
}
